export default "__VITE_ASSET__CoO36SgR__"